import { __assign, __awaiter, __generator } from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit, } from '@angular/core';
import { select, Store } from '@ngrx/store';
import Root from '@react/components/Root';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { combineLatest, Subscription } from 'rxjs';
import * as fromAuth from '../../../auth/reducers';
import SwitchPortal from '../../../react/components/switchPortal';
import * as fromSettings from '../../../settings/reducers';
import { CognitoWrapperService } from '../../services/congito.wrapper.service';
var containerElementName = 'switchPortalReactWrapperComponent';
var SwitchPortalReactWrapperComponent = /** @class */ (function () {
    function SwitchPortalReactWrapperComponent(_store, _cognito) {
        this._store = _store;
        this._cognito = _cognito;
        this._subscriptions = new Subscription();
    }
    SwitchPortalReactWrapperComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions.add(combineLatest([
            this._store.pipe(select(fromAuth.getClinicId)),
            this._store.pipe(select(fromAuth.getClinicOptions)),
            this._store.pipe(select(fromAuth.getUser)),
            this._store.pipe(select(fromSettings.getCurrentLanguage)),
            this._store.pipe(select(fromSettings.getLanguageTranslations)),
        ]).subscribe(function (_a) {
            var clinicToken = _a[0], clinicOptions = _a[1], user = _a[2], language = _a[3], translations = _a[4];
            _this._props = {
                clinicToken: clinicToken,
                features: clinicOptions,
                language: language,
                translations: translations,
                user: user,
            };
            _this.render();
        }));
    };
    SwitchPortalReactWrapperComponent.prototype.ngOnDestroy = function () {
        ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
        this._subscriptions.unsubscribe();
    };
    SwitchPortalReactWrapperComponent.prototype.ngAfterViewInit = function () {
        this.render();
    };
    SwitchPortalReactWrapperComponent.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                ReactDOM.render(React.createElement(Root, __assign(__assign({}, this._props), { authService: this._cognito, dispatch: this._store.dispatch.bind(this._store), children: React.createElement(SwitchPortal, {
                        clinicName: this.clinic,
                        clinicToken: this._props.clinicToken,
                    }) })), this.containerRef.nativeElement);
                return [2 /*return*/];
            });
        });
    };
    return SwitchPortalReactWrapperComponent;
}());
export { SwitchPortalReactWrapperComponent };
